var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgencyComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1908_26794)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1908_26794)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1908_26794)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1908_26794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2035 27.2822L53.8955 23.9742C52.8727 22.9513 51.2153 22.9513 50.1925 23.9742L46.8834 27.2822C45.8605 28.305 45.8605 29.9624 46.8834 30.9853L50.1913 34.2932C51.2142 35.3161 52.8715 35.3161 53.8944 34.2932L57.2024 30.9853C58.2253 29.9624 58.2253 28.305 57.2035 27.2822ZM53.0452 31.7432C53.0452 32.2964 52.5966 32.745 52.0434 32.745C51.4903 32.745 51.0417 32.2964 51.0417 31.7432V31.5429C51.0417 30.9897 51.4903 30.5412 52.0434 30.5412C52.5966 30.5412 53.0452 30.9897 53.0452 31.5429V31.7432ZM53.0452 28.8983C53.0452 29.4515 52.5966 29.9 52.0434 29.9C51.4903 29.9 51.0417 29.4515 51.0417 28.8983V26.5242C51.0417 25.971 51.4903 25.5224 52.0434 25.5224C52.5966 25.5224 53.0452 25.971 53.0452 26.5242V28.8983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0436 36.7333C50.8982 36.7333 49.8208 36.287 49.0105 35.4767L45.7025 32.1676C44.8923 31.3585 44.447 30.2821 44.447 29.1357C44.447 28.8708 44.476 28.6115 44.5227 28.3555H32.5141C30.5997 28.3566 29.0303 29.9148 29.0303 31.8515V44.1618C29.0303 46.0762 30.5997 47.6456 32.5141 47.6456H37.7899L40.5391 50.4282C41.0177 50.918 41.8303 50.918 42.3089 50.4282L45.0581 47.6456H50.3228C52.2595 47.6456 53.8177 46.0874 53.8177 44.1618V36.3371C53.2668 36.5898 52.668 36.7333 52.0436 36.7333ZM36.0859 39.4803C35.2756 39.4803 34.6189 38.8236 34.6189 38.0133C34.6189 37.203 35.2756 36.5464 36.0859 36.5464C36.8961 36.5464 37.5528 37.203 37.5528 38.0133C37.5528 38.8236 36.8973 39.4803 36.0859 39.4803ZM41.4184 39.4803C40.6081 39.4803 39.9515 38.8236 39.9515 38.0133C39.9515 37.203 40.6081 36.5464 41.4184 36.5464C42.2287 36.5464 42.8854 37.203 42.8854 38.0133C42.8854 38.8236 42.2287 39.4803 41.4184 39.4803ZM46.7499 39.4803C45.9396 39.4803 45.2829 38.8236 45.2829 38.0133C45.2829 37.203 45.9396 36.5464 46.7499 36.5464C47.5602 36.5464 48.2169 37.203 48.2169 38.0133C48.2169 38.8236 47.5602 39.4803 46.7499 39.4803Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1908_26794",
    x: 0.5,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.564706 0 0 0 0 0.690196 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1908_26794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1908_26794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1908_26794",
    x: 23.0303,
    y: 21.207,
    width: 40.9395,
    height: 39.5879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1908_26794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1908_26794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1908_26794",
    x: 23.0303,
    y: 21.207,
    width: 40.9395,
    height: 39.5879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1908_26794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1908_26794",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_26794",
    x1: 43.5,
    y1: 12,
    x2: 43.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B325F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyComplaints);
export default __webpack_public_path__ + "static/media/AgencyComplaints.f117ff6bf1b55c261b90bdbc1fc56fcf.svg";
export { ForwardRef as ReactComponent };